import { createSelector } from '@reduxjs/toolkit';

const selectActiv8ArchiveBucketById = createSelector(
  (state) => state.activ8Settings.content,
  (_, bucketId) => bucketId,
  (content, bucketId) => content.find((item) => item.bucketId === bucketId) ?? {},
);

export { selectActiv8ArchiveBucketById };
